import type { PivotConfig } from "@/lib/analytics/pivot";

export type TileOutput = "table" | "chart";
export type TileChartType = "bar" | "line" | "pie";

/** One pivot table on the report canvas. */
export interface ReportTile {
  id: string;
  title: string;
  config: PivotConfig;
  output: TileOutput;
  chartType: TileChartType;
}

/** The whole canvas/report. */
export interface ReportDoc {
  name: string;
  tiles: ReportTile[];
}

/** Server-saved report metadata (list view). */
export interface SavedReportMeta {
  id: number;
  name: string;
  updatedAt: string;
}

export function defaultTile(id: string, title: string): ReportTile {
  return {
    id,
    title,
    config: {
      mode: "pivot",
      rowFields: ["department"],
      colField: undefined,
      values: [],
      filters: [],
      flatColumns: ["name", "department", "status", "contract_type"],
    },
    output: "table",
    chartType: "bar",
  };
}
